/**
 * Job-level tokens that require a Bonus Type on Job Level Change amends.
 * Boundary-aware so 5A/6B do not match, while "1B (Board)" and "Level 4B" do.
 */
const JOB_LEVEL_TOKEN = /\b[1-4][AB]\b/i;
/** Case-insensitive Sales exclusion on the combined contract + level label. */
const SALES_EXCLUSION = /sales/i;
/**
 * Whether Bonus Type should be shown (and required) for a Job Level Change.
 * Uses `{newContractType} - {newJobLevel}` so any Admin Panel contract whose
 * job-level item contains 1A–4B is covered without hard-coding family names.
 */
export function amendRequiresBonusType(newContractType, newJobLevel) {
    if (!newContractType?.trim() || !newJobLevel?.trim()) {
        return false;
    }
    const combined = `${newContractType} - ${newJobLevel}`;
    if (SALES_EXCLUSION.test(combined)) {
        return false;
    }
    return JOB_LEVEL_TOKEN.test(combined);
}
